<!--
Copyright 2025 Google LLC. This software is provided as-is, without warranty 
or representation for any use or purpose. Your use of it is subject to your 
agreement with Google.
-->
<div class="preview-panel" *ngIf="selectedCitation" #previewPanel>
        <div class="preview-header">
            <span class="preview-title">
                <img src="../../assets/preview.svg" alt="bot-avatar" class="preview-icon">Preview
            </span>
            <div>
                <span style="float: right;cursor: pointer; display: flex;"
                    (click)="closePreview()">
                    <mat-icon aria-label="close icon" fontIcon="close"></mat-icon>
                </span>
            </div>
        </div>
        <div class="preview-content">
            <span class="d-flex w-100 gap-2 mb-2">
                <img src="../../assets/asco-thumbnail.png" alt="asco-thumbnail" class="ask-logo">
                <a href="https://www.ASCOPubs.org" target="_blank" style="text-decoration: none;"
                    class="asco-url">www.ASCOPubs.org</a>
            </span>
            <a href={{selectedCitation.uri}} target="_blank" rel="noopener noreferrer">
                {{selectedCitation.title}}
            </a>
            <div>
                <span class="preview-label">Last updated: </span>
                <span class="preview-value">
                    {{displayLastEditDate(selectedCitation.publish_date)}}</span>
            </div>
            <div *ngFor="let sec of selectedCitation.content_sections" class="d-flex flex-column">
                <span class="preview-label">{{sec.section_title}}</span>
                <span class="preview-value" [innerHtml]='modifyContent(sec.section_content) | safeHtml'></span>
            </div>
        </div>
</div>
<div class="preview-panel flex-column" *ngIf="!selectedCitation && previewPanelError">
    <div class="preview-header vh-6">
        <span class="preview-title">
            <img src="../../assets/bot-icon.png" alt="bot-avatar" class="preview-icon">Preview
        </span>
        <div>
            <span style="float: right;cursor: pointer; display: flex;"
                (click)="closePreview()">
                <mat-icon aria-label="close icon" fontIcon="close"></mat-icon>
            </span>
        </div>
    </div>
    <div class="preview-error-message">
        <div class="error-message">
            <img src="../../assets/error.png" alt="asco-thumbnail" class="error-icon">
            <span class="error-title">Something went wrong</span>
            <span class="error-subtitle">An error has occurred. Please try again later.</span>
        </div>
    </div>
</div>